import React, { Component } from 'react'
import Header from '../Components/header/index.jsx'
import Footer from '../Components/Footer/index'
import { useParams } from 'react-router-dom'
import './index.scss'
import { Link } from 'react-router-dom'

const queryString = require('query-string')

function titleName(id) {
  let titlename = ''
  if (id == 1) {
    titlename = '智能井盖解决方案'
  } else if (id == 2) {
    titlename = '工业厂区安全生产综合管理解决方案'
  } else if (id == 3) {
    titlename = '数据可视化云平台'
  } else if (id == 4) {
    titlename = '厂区安全生产监测解决方案'
  }
  document.title = titlename + '北京锐控自动化科技有限公司'

  return titlename
}
export default function () {
  const { id } = useParams()

  return (
    <div style={{ background: '#f6f6f6' }}>
      <Header></Header>
      <div className="journalism">
        <div className="journalism-solution">
          <div className="journalism-solution-item"> 当前位置：</div>
          <div className="journalism-solution-item"> 首页 ></div>
          <div className="journalism-solution-item">产品中心 ></div>
          <div className="journalism-solution-item"> 解决方案 > </div>
          <div className="journalism-solution-item" style={{ color: '#2176D0' }}>
            {titleName(id)}
          </div>
        </div>
        <div className="journalism-content">
          {id != 5 ? (
            <div className="journalism-content-h1">{titleName(id)}</div>
          ) : (
            <div className="journalism-content-h1" style={{ paddingBottom: '.457143rem ' }}>
              <div className="journalism-content-h1-text">喜讯！锐控高端光电编码器芯片成功实现量产</div>
              <div className="journalism-content-h1-time">2023-03-18</div>
            </div>
          )}

          {/* 智能井盖 */}
          {id == 1 && (
            <div className="journalism-content-details">
              <div className="journalism-content-details-item">
                <img src={require('../image/井盖.png')} className="journalism-content-details-item-img"></img>
                <div className="journalism-content-details-item-title">系统概述</div>
                <div className="journalism-content-details-item-test">RS485通讯采用标准的MODBUS通讯协议，通信接口的远程数据采集方法，可实现通信距离几十米到上千米, 适用于管廊、电力隧道等有外部供电的自动化系统。</div>
                <div className="journalism-content-details-item-title">主要功能</div>
                <div className="journalism-content-details-item-test">NB-IOT物联网通讯是IoT领域一个新兴的技术，支持低功耗设备在广域网的蜂窝数据连接，也被叫作低功耗广域网(LPWAN)。</div>
              </div>
              <div className="journalism-content-details-item">
                <img src={require('../image/井盖1.png')} className="journalism-content-details-item-img"></img>
                <div className="journalism-content-details-item-title">系统概述</div>
                <div className="journalism-content-details-item-test2">本公司智能井盖云平台，结合网络技术、信息技术、整合技术、管理平台技术、应用技术等，将智能井盖、各类传感器、管理人员和维护人员通过无线的方式连接在一起，云端存取数据、数据比对、逻辑判断，可完成设备监控、报警记录、趋势分析、报警推送、派单维修、后台管理等功能，能够及时发现报警并定位，随时随地可进行监测、派单维修。界面操作简洁高效，事件记录清晰完整，产品设计结合智慧城市管理规范，满足智慧城市的各项管理需求。</div>
              </div>
            </div>
          )}
          {/* 智能井盖 */}
          {/* 工业厂区安全生产综合管理解决方案 */}
          {id == 2 && (
            <div className="journalism-content-details1">
              <div className="journalism-content-details1-item">
                <div className="journalism-content-details1-item-title">系统概述</div>
                <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '2' }}>
                  系统基于现有物联网技术、移动互联网技术，为用户提供智能化、移动化、一体化的安全生产综合监测系统，最大限度地满足企业对生产运行环节的安全监测需求，帮助企业用户建立一套完善的安全生产体系。
                </div>
              </div>
              <div className="journalism-content-details1-imgBox">
                <img src={require('../image/工厂2.png')} className="journalism-content-details1-imgBox-image" />
                <img src={require('../image/工厂1.png')} className="journalism-content-details1-imgBox-image" />
              </div>
              <div className="journalism-content-details1-item-title">系统架构</div>
              <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '5' }}>
                系统整体由三部分组成，分别是监测预警中心、安全处理指挥中心及综合展示中心。监测预警中心主要通过高精度传感和监测设备、无线通信技术对设备运行的各参数进行实时监测，帮助用户掌握厂区生产过程的各设备的运行情况及状态。安全处理指挥中心（调度中心），监测预警中心的报警信息会实时反馈到指挥中心，指挥中心收到报警信息会进行研判，如果是需要紧急处理的时间，系统会立即启动预案，通知相关负责人进行联动处理，系统为用户提供了丰富的资源和智能化支持，帮助用户进行决策处理和指挥调度，直至报警解除。综合展示中心使得系统资源可以在不同多终端（如：LED大屏、桌面PC、智能手机等）进行展示，并具备友好的用户图形界面交互模式，帮助用户建立完善的安全生产体系。
              </div>
              <div className="journalism-content-details1-item-title" style={{ marginTop: ' 0.857143rem ' }}>
                系统特点
              </div>
              <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '5' }}>
                a. 一体化综合系统：系统整合现有资源，并增设智能传感器，提升系统监测性能，做到无死角一体化监测。开放的接口设计，保障系统的扩展能力，并可根据用户需求进行定制开发。
                <br />
                b. 技术稳定成熟：系统设计采用物联网技术、移动互联网技术等，保证系统的稳定、高效和高质量。
                <br />
                c. 友好的用户体验：用户的体验是我司一直重点关注的，在友好的用户体验方面我们积极汲取用户意见，不断完善设计，为给用户提供更友好的体验不懈努力。
                <br />
              </div>
            </div>
          )}
          {/* 工业厂区安全生产综合管理解决方案 */}
          {/* 数据可视化云平台 */}
          {id == 3 && (
            <div className="journalism-content-details">
              <div className="journalism-content-details-item">
                <img src={require('../image/可视化1.png')} className="journalism-content-details-item-img"></img>
                <div
                  className="journalism-content-details-item-title"
                  style={{
                    fontWeight: 600
                  }}
                >
                  系统概述
                </div>
                <div className="journalism-content-details-item-test">助力企业和政府在数字生活、数字城市、数字能源、物联网等领域进行数字化转型。</div>
                <div
                  className="journalism-content-details-item-title"
                  style={{
                    fontWeight: 600
                  }}
                >
                  主要功能
                </div>

                <div className="journalism-content-details-item-test" style={{ WebkitLineClamp: '4' }}>
                  • 多样化的数据源集成
                  <br />
                  • 丰富的主题组件
                  <br />
                  • 便捷的可视化设计
                  <br />• 实现全网数据的集约化汇聚
                </div>
              </div>
              <div className="journalism-content-details-item">
                <img src={require('../image/可视化2.png')} className="journalism-content-details-item-img"></img>

                <div
                  className="journalism-content-details-item-title"
                  style={{
                    fontWeight: 600
                  }}
                >
                  系统特点
                </div>
                <div className="journalism-content-details-item-test2" style={{ lineHeight: '1rem' }}>
                  • 实现高效、经济、开放、安全、高质的基础平台,可扩展性强
                  <br />
                  • 适应互联网时代的数据化市场经营、企业管理、精细运营、企业数据价值变现的需求
                  <br />
                  • 数据缓存，具计算分析能力,4G无线传输
                  <br />
                  • 针对小数据量控制设备/仪表数据做采集
                  <br />
                  • 新一代信息技术与制造业深度融合，标准化智能化，个性化
                  <br />• 数据模型构建整合现有网络、业务平台和MOB域等业务数据
                </div>
              </div>
            </div>
          )}
          {/* 数据可视化云平台 */}
          {/* 厂区安全生产监测解决方案 */}
          {id == 4 && (
            <div className="journalism-content-details1">
              <div className="journalism-content-details1-item">
                <div className="journalism-content-details1-item-title">系统概述</div>
                <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '2' }}>
                  提供软硬结合的安全生产监控方案，基于厂区、车间内摄像头采集的图像，监测职工是否符合安全着装规范、作业规范，检测职工及作业车辆的违规离岗、违规闯入、违规停留等行为，综合评估厂区的合规度，为企业评估安全生产管理状况并采用针对性的提升方法提供精准依据。
                </div>
              </div>
              <div className="journalism-content-details1-imgBox">
                <img src={require('../image/厂区1.png')} className="journalism-content-details1-imgBox-image" />
                <img src={require('../image/厂区.png')} className="journalism-content-details1-imgBox-image" />
              </div>
              <div className="journalism-content-details1-item-title">系统架构</div>
              <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '5' }}>
                在厂区内布设摄像头采集视频，通过前置计算设备或服务器集成的定制化识别模型进行分析，针对不同的摄像头，灵活配置监控的事件及使用的模型，实时将危险事件及各种统计结果反馈给工厂安全生产管理系统，实现生产管理联动。
              </div>
              <div className="journalism-content-details1-item-title" style={{ marginTop: ' 0.857143rem ' }}>
                系统特点
              </div>
              <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '4' }}>
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 员工安全着装规范识别：</span>检测员工着装是否符合安全防护标准，如：安全帽、静电帽、工作服、手套、口罩、绝缘靴等。
                <br />
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 作业区危险行为监测：</span>实时监测作业区使用手机、抽烟、跌倒、人员违规闯入、车辆违规停留等行为，及时预警。
                <br />
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 生产机械安全监控：</span>监控各种生产设备、工作区的安全作业情况，如：行吊的起吊高度、绞龙启动后防护区是否有人员逗留。
                <br />
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 仪表盘读数识别：</span>实时监控各种仪表盘指针读数，判断指标是否合格，如：液化气罐异常指标报警、厂区内粉尘浓度监测。
              </div>
              <div className="journalism-content-details1-item-title" style={{ marginTop: ' 0.857143rem ' }}>
                应用场景
              </div>
              <div className="journalism-content-details1-item-content" style={{ WebkitLineClamp: '4' }}>
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 生产车间：</span>全方位监控评估生产车间内的人员作业、机械设备、作业车辆，帮助企业及管理机构全面及时地了解企业安全生产状况，并可以根据监控统计结果及分析数据，作为加强安全生产管理水平的参考依据。
                <br />
                <span style={{ color: '#2176D0', fontWeight: '600' }}>• 工厂园区：</span>实时监控评估工厂园区内的室外生产作业安全状况，分析园区的安全运输、人员作业情况，及时发现、告警违规行为，减少安全隐患，保障人身财产安全。
                <br />
              </div>
            </div>
          )}
          {/* 厂区安全生产监测解决方案 */}
          {id == 5 && (
            <div className="journalism-content-details2">
              <div className="journalism-content-details2-text"> 　　光电传感器在生活中随处可见，然而其核心部分光电芯片一直是我国被卡脖子的“痛点”高科技产业。光电编码器芯片就是其中之一。在各类电机控制系统中，光电编码器对控制系统的性能起决定性作用。编码器将信号或数据进行编制，转换为可用于通讯、传输和存储的信号形式，对电机的定位精度、速度稳定性、功率损耗和安全性都有重要影响。如今，传周半导体打破高端光电编码器芯片多年的外国垄断局面，成功实现量产。</div>
              <div className="journalism-content-details2-text"> 　　锐控团队经过严苛的光学设计、光电芯片设计、流片工艺研发、封装测试等各环节的流程把控，于2023年3月正式宣布，其TV-PA3911-C、TV-OEC-FB和TV-OEC-A型号的光电编码器芯片及编码器信号调理芯片成功实现量产。此次量产的编码器芯片，具有高精度、安全可靠、性能稳定、减少串扰等技术突破。采用“5通道光学游标编码差分扫描技术”输出模拟正弦/余弦波信号，精度达到2048 CPR，支持26位高精度光电编码器系统。该系列芯片采用先进的封装技术，具有较强的机械性能、良好的电气性能和散热性能，保证了芯片正常工作的高稳定性和可靠性。同时带有温度过高保护系统，可以对反向电源电压进行保护。</div>
              <div className="journalism-content-details2-img">
                <div className="journalism-content-details2-img-item"></div>
                <div className="journalism-content-details2-img-item"></div>
              </div>
            </div>
          )}
          {id != 5 && (
            <Link to="/contactus.html">
              <div className="journalism-content-option"> 联系我们 </div>{' '}
            </Link>
          )}
        </div>
      </div>
      <Footer />
    </div>
  )
}

// export default class index extends Component {
//   componentWillMount() {

//   }
//   render() {
//     return (
//       <div style={{ background: '#f6f6f6' }}>
//         <Header></Header>
//         <div className="journalism">
//           <div className="journalism-solution">
//             <div className="journalism-solution-item"> 当前位置：</div>
//             <div className="journalism-solution-item"> 首页 ></div>
//             <div className="journalism-solution-item">产品中心 ></div>
//             <div className="journalism-solution-item"> 解决方案 > </div>
//             <div className="journalism-solution-item"> 解决方案 > </div>
//           </div>
//           <div className="journalism-content">
//             <div className="journalism-content-h1">智能井盖解决方案</div>
//             <div className="journalism-content-details">
//               <div className="journalism-content-details-item">
//                 <div className="journalism-content-details-item-img"></div>
//                 <div className="journalism-content-details-item-title">系统概述</div>
//                 <div className="journalism-content-details-item-test">RS485通讯采用标准的MODBUS通讯协议，通信接口的远程数据采集方法，可实现通信距离几十米到上千米, 适用于管廊、电力隧道等有外部供电的自动化系统。</div>
//                 <div className="journalism-content-details-item-title">主要功能</div>
//                 <div className="journalism-content-details-item-test">NB-IOT物联网通讯是IoT领域一个新兴的技术，支持低功耗设备在广域网的蜂窝数据连接，也被叫作低功耗广域网(LPWAN)。</div>
//               </div>
//               <div className="journalism-content-details-item">
//                 <div className="journalism-content-details-item-img"></div>
//                 <div className="journalism-content-details-item-title">系统概述</div>
//                 <div className="journalism-content-details-item-test2">本公司智能井盖云平台，结合网络技术、信息技术、整合技术、管理平台技术、应用技术等，将智能井盖、各类传感器、管理人员和维护人员通过无线的方式连接在一起，云端存取数据、数据比对、逻辑判断，可完成设备监控、报警记录、趋势分析、报警推送、派单维修、后台管理等功能，能够及时发现报警并定位，随时随地可进行监测、派单维修。界面操作简洁高效，事件记录清晰完整，产品设计结合智慧城市管理规范，满足智慧城市的各项管理需求。</div>
//               </div>
//             </div>

//             <div className="journalism-content-option">联系我们</div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     )
//   }
// }
